import { Component, OnInit } from '@angular/core';
import Stepper from 'bs-stepper';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import { UserserviceService } from 'src/hp-app/services/userservice.service';
import {ProductDocument} from 'src/hp-app/models/productdocument';
import { Address } from 'src/hp-app/models/address';
import { OrderDetails } from 'src/hp-app/models/orderdetails';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/components/common/messageservice';


@Component({
  selector: 'app-check-out',
  templateUrl: './check-out.component.html',
  styleUrls: ['./check-out.component.css']
})
export class CheckOutComponent implements OnInit {

  private stepper: Stepper;
  addressForm: FormGroup;
  documentId : number;
  countryId: number;
  language: string;
  selectedDocumentList : ProductDocument[] = [];
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  blockSpace: RegExp = /[^\s]/;
  countryregionList: Array<any>;
  isValidFormSubmitted = null;
  address : Address = new Address();
  orderdetails : OrderDetails;
  checked = false;
  is_checkout = false;
  is_important = true;
  isloader = false;
  direction: string = "ltr";

  constructor(private formBuilder: FormBuilder, private _http: UserserviceService,
              private router: Router,private translate: TranslateService,private messageService:MessageService) {

    this.GetselectedDocuments();
    this.language = this._http.getGlobalLanguage();
    if (this.language.toLowerCase() == "ar") {
      this.direction = "rtl";
    }
    translate.use(this.language);
  }

  ngOnInit() {
    this.stepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    });

    this.addressForm = this.formBuilder.group({
      name: ['', [Validators.required, this.noWhitespaceValidator]],
      addressline1: ['', [Validators.required, this.noWhitespaceValidator]],
      addressline2: [''],
      country: ['', Validators.required],
      state: ['', [Validators.required, this.noWhitespaceValidator]],
      city: ['', [Validators.required, this.noWhitespaceValidator]],
      postalcode: [''],
      email: ['', [Validators.required]],
      specialinstructions:[''],
      resdelivery:['']
    });

    this.GetCountryList();

    if(sessionStorage.getItem("address") != null){
       this.address = JSON.parse(sessionStorage.getItem("address"));
       this.checked = this.address.resdelivery;
       this.addressForm.patchValue(this.address);

    }
  }

  /**
   *  @description Method to get Country/RegionList 
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  GetCountryList(){
    this._http.getCountryList().subscribe(
      data => {
        this.countryregionList = data;
      }, err => {
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
    )
  }

  /**
   *  @description Method to get Selected Documents from Session storage 
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  GetselectedDocuments(){
    if(sessionStorage.getItem('documentlist') != null){
      this.selectedDocumentList = JSON.parse(sessionStorage.getItem('documentlist'));
      if(this.selectedDocumentList.length == 0){
        this.is_checkout = true;
      }
    }else{
        this.router.navigate(['/dashboard']);
    }
  }

   /**
   *  @description Method to Change the Quantity  and reassign
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  QunatityChange(documentId,quantity){
   
    this.selectedDocumentList = [];

    if(sessionStorage.getItem('documentlist') != null){
      this.selectedDocumentList = JSON.parse(sessionStorage.getItem('documentlist'));
    };
    if(quantity <= 0){
      quantity = 1;
    }
    this.selectedDocumentList.find( item => item.documentId == documentId).quantity = +quantity;

    sessionStorage.setItem('documentlist', JSON.stringify(this.selectedDocumentList));
  }

   /**
   *  @description Method to Remove Selected Document from the seesion storage based on documentId
   *  @author HariKiran 
   *  @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  RemoveProdcut(documentId){

    this.selectedDocumentList = JSON.parse(sessionStorage.getItem('documentlist'));

     let prod = new ProductDocument();

     prod = this.selectedDocumentList.find(s=> s.documentId == documentId);

     let index = this.selectedDocumentList.indexOf(prod);

      if (index !== -1) {
        this.selectedDocumentList.splice(index, 1);
      } 
    
      sessionStorage.setItem('documentlist', JSON.stringify(this.selectedDocumentList));
      
      if(this.selectedDocumentList.length == 0){
        this.is_checkout = true;
      }
  }

   /**
   *  @description Method to redirect to Dashboard page to Continue shopping 
   *  @author HariKiran 
   *  @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  ContinueShopping() {
    this.is_important = true;
    this.router.navigate(['/dashboard']);
    this.is_checkout = false;
    this.is_important = true;
  }

   /**
   *  @description Method to Move to  Place Order screen from Add Adress screen
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  Movenext(){
    
    this.isValidFormSubmitted = false;
    if (this.addressForm.invalid) {
      return;
    }
    this.isValidFormSubmitted = true;
    this.is_important = false;

    this.address = new Address();

    this.address = this.addressForm.value;

    sessionStorage.setItem("address",JSON.stringify(this.address));

    this.next();
   
  }

   /**
   *  @description Method to place the Order from Place Order Screen 
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  onSubmit() {
    this.isValidFormSubmitted = false;

    if (this.addressForm.invalid) {
      return;
    }

    if (sessionStorage.getItem("documentlist") == null || sessionStorage.getItem("documentlist") == undefined)
      return;

    if (sessionStorage.getItem("address") == null || sessionStorage.getItem("address") == undefined)
      return;



    this.isValidFormSubmitted = true;

    this.address = new Address();

    this.address = JSON.parse(sessionStorage.getItem("address"));
    
    this.selectedDocumentList = JSON.parse(sessionStorage.getItem('documentlist'));

    this.orderdetails = new OrderDetails();

    this.orderdetails.address = this.address;

    this.orderdetails.documentlist = this.selectedDocumentList;

    this.isloader = true;

    console.log(this.orderdetails);

    this._http.AddOrder(this.orderdetails).subscribe(
      data => {
        sessionStorage.removeItem("address");
        sessionStorage.removeItem("documentlist");
        let id = data["orderId"];
        this.isloader = false;
        this.router.navigate(['/dashboard/order-summary', id]);
      }, err => {
        this.isloader = false;
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
    )
  }

   /**
   *  @description Method to move from Cart Details to Add Address screen 
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  next() {
    this.stepper.next();
  }

   /**
   *  @description Method to go to Previous screen 
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  previous() {
    this.stepper.previous();
    this.is_important = true;
  }
  
   /**
   *  @description Method to accept only numbers on phone and PostCode Input fields
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof CheckOutComponent 
   * */
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  get name() {
    return this.addressForm.get('name');
  }
  get addressline1() {
    return this.addressForm.get('addressline1');
  }
  get addressline2() {
    return this.addressForm.get('addressline2');
  }
  get country() {
    return this.addressForm.get('country');
  }
  get state() {
    return this.addressForm.get('state');
  }
  get city() {
    return this.addressForm.get('city');
  }
  get postalcode() {
    return this.addressForm.get('postalcode');
  }
  get email() {
    return this.addressForm.get('email');
  }
  get specialinstructions() {
    return this.addressForm.get('specialinstructions');
  }
  get resdelivery() {
    return this.addressForm.get('resdelivery');
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  ltrim(value) {
    if (value.trim() == '') {
      value = '';
    }
    return value;
  }

  getCSSClasses() {
    let cssClasses;

    if (this.language.toLowerCase() == "arabic") {
      cssClasses = {
        'text-right': true
      }
    }
    else {
      cssClasses = {
        'text-right': false
      }
    }
    return cssClasses;
  }
}
